// src/firebase/config.js
// ADD getStorage export — needed for announcement attachments
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import {
  initializeFirestore,
  memoryLocalCache,
} from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyB0iP18yTA5J8aGgybDYrTr6wxRVy8u6mk",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "trendlance-hrms.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "trendlance-hrms",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "trendlance-hrms.firebasestorage.app",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "550488441162",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:550488441162:web:97fba3f07047f4b19bc1b3",
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const storage = getStorage(app);   // ← NEW

export const db = initializeFirestore(app, {
  localCache: memoryLocalCache(),
  experimentalForceLongPolling: true,
  useFetchStreams: false,
});

export default app;